// Alto de la lista de tiendas del modo "a varias tiendas" del modal Crear Tarea.
//
// Está en su propio archivo, y no dentro de `AddTicket.js`, para que se pueda probar:
// `AddTicket.js` arrastra React y medio store, y un runner standalone no lo puede importar.
// Los casos viven en `storeListHeight.checks.mjs`.
//
// El máximo es el alto histórico (`max-h-80`). El mínimo son ~3 filas, y es un OBJETIVO,
// no una garantía: cuando el hueco disponible es menor, forzarlo devuelve el bug que este
// cálculo viene a evitar, porque las filas que sobran quedan debajo del footer del modal
// y ahí no llega ni el click ni la rueda.
//
// Medido en Claro CR (2026-09-01, viewport de 621 px de alto): el hueco real es de 66 px.
// Forzando el mínimo de 120 la lista se pasa 46 px y una de las cuatro filas visibles deja
// de ser clickeable; respetando los 66 px entran las dos filas que muestra y las dos andan.
// Por debajo del piso absoluto la lista no muestra ni una fila entera y deja de tener sentido.
export const STORE_LIST_MAX_HEIGHT = 320
export const STORE_LIST_MIN_HEIGHT = 120
export const STORE_LIST_FLOOR_HEIGHT = 64
export const STORE_LIST_BOTTOM_GAP = 8

export const computeStoreListHeight = (available) => {
    if (!Number.isFinite(available)) {
        return STORE_LIST_MAX_HEIGHT
    }

    // Si el hueco da para el mínimo, la lista lo usa hasta el máximo histórico. Si no da,
    // manda el hueco: una lista más larga que el espacio disponible es exactamente el bug.
    const height = available >= STORE_LIST_MIN_HEIGHT
        ? Math.min(STORE_LIST_MAX_HEIGHT, available)
        : Math.max(STORE_LIST_FLOOR_HEIGHT, available)

    return Math.round(height)
}
